module.exports = __webpack_public_path__ + "static/skateboarding-child-mobile.e36f5e61.webp";